import { CommentsList, type CommentsListProps } from './CommentsList';

export interface CommentsTabProps extends CommentsListProps {}

/**
 * Comments tab — currently a 1:1 wrapper of CommentsList. Exists so the rail's
 * tab-slot API stays symmetric (ToolsTab / CommentsTab / AskAITab) and so any
 * future Comments-specific chrome (e.g. filter pills, "Add comment" CTA) lands
 * here without churning consumers.
 */
export function CommentsTab(props: CommentsTabProps) {
  return <CommentsList {...props} />;
}
